module.exports = __webpack_public_path__ + "img/1.d607bb3b.png";